import { Outlet } from "react-router-dom";

function CustomerQuotationMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default CustomerQuotationMain;